import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        container: {
            display: 'flex',
            marginTop: theme.spacing(2),
            '& > *': {
                flex: 1,
            },
        },
        content: {
            paddingTop: `${theme.spacing(1)} !important`,
        },
    }
})
